// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uIgI","title":"styles_title__2wh1c"};